import { FC } from 'react';

import { Button } from 'ui/components/common';
import useModal from 'ui/partials/Modal/useModal';
import { cn, convertToMegabytes } from 'utils/helpers';

interface PROPS {
  fileSize?: string;
  maxSize?: number;
}

const AttachmentsTooLargeModal: FC<PROPS> = ({
  fileSize = 15,
  maxSize = 0,
}) => {
  const { hideModal } = useModal();

  return (
    <>
      <div className="_modal-content-body space-y-[6px]">
        <div
          className={cn(
            'font-semibold',
            'text-sm',
            'leading-6',
            'tracking-wider',
          )}
        >
          The attachment exceeds the allowable limit.
        </div>
        <div>
          {`The accumulated file size you are trying to upload is
        ${fileSize}. This exceeds the maximum allowed limit of ${convertToMegabytes(
          maxSize,
        ).replace(
          /\.\d+/,
          '',
        )}. Please choose smaller files or reduce the number of files."`}
        </div>
      </div>
      <div className="_modal-buttons">
        <Button onClick={hideModal} label="OK" className="primary sm" />
      </div>
    </>
  );
};

export default AttachmentsTooLargeModal;
